/**
 * Generates a consistent key for identifying media in annotations
 * @param mediaSetId - The ID of the media set
 * @param mediaKey - The key of the specific media item
 * @returns A formatted string key or empty string if inputs are invalid
 */
export function generateMediaKey(mediaSetId: string | null, mediaKey: string | null): string {
  if (!mediaSetId || !mediaKey) return "";
  return `${mediaSetId}:${mediaKey}`;
}
